import { ReactNode } from 'react'

interface CardProps {
	children: ReactNode | ReactNode[]
	className?: string
	isRoot?: boolean
	useDefaultPadding?: boolean
}

const Card = ({ children, isRoot = true, useDefaultPadding = true, className, ...rest }: CardProps) => {
	const cornerRadius = isRoot ? 'rounded-2xl' : 'rounded-xl'
	const padding = useDefaultPadding ? 'p-5 md:p-6' : ''

	return (
		<div
			className={`${cornerRadius} border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03] ${padding} ${className}`}
			{...rest}
		>
			{children}
		</div>
	)
}

export default Card
